import request from '../utils/request'

export const api = {
  promptWord: {
    getLabels() {
      return request.get('/api/ai/prompt-word/label/list')
    },
    getList(params) {
      return request.get('/api/ai/prompt-word/list', { params })
    }
  },
  workflow: {
    getLabels() {
      return request.get('/api/ai/workflow/label/list')
    },
    getList(params) {
      return request.get('/api/ai/workflow/list', { params })
    },
    getDetail(id) {
      return request.get(`/api/ai/workflow/${id}`)
    },
    getDownload(id) {
      return request.get(`/api/ai/workflow/${id}/download`).then(data => {
        console.log(data)
        return [... data.package];
      })
    }
  }
}
